import {
    ADD_POINT_PARAMS, APPOINTMENT_EVALUATED_BEFORE,
    GET_EVALUATE_APPOINTMENT, SET_TOKEN,
} from '../constants/actionTypes'

const initialState = {questionPointArr:[]};

const evaluateReducer = (state = initialState, action) => {

    //console.log("action11---",action);
    switch (action.type) {
        case GET_EVALUATE_APPOINTMENT:
            return {
                ...state,
                evaluateAppointment: action.payload,
            };
        case ADD_POINT_PARAMS:
            let arr=state.questionPointArr;
            arr.push(action.payload);
            return {
                ...state,
                questionPointArr:arr,
            };
        case SET_TOKEN:
            return {
                ...state,
                token: action.payload,
            };
        case APPOINTMENT_EVALUATED_BEFORE:
            return {
                ...state,
                evaluated:true
            }
        default:
            return state;
    }
};

export default evaluateReducer;